import { useDisclosure } from "@mantine/hooks";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { Box, Button, Group, Text } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";

const DeleteTestLevel = ({
  listId,
  onSuccess,
}: {
  listId: number[];
  onSuccess: any;
}) => {
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const handleDelete = async () => {
    open();
    try {
      const res = await repositoryMdm.post<MessageResponse<boolean>>(
        "/api/v1/TechnicalTestLevel/delete",
        listId,
      );
      if (res && res.success) {
        NotificationExtension.Success("Xóa mức độ test thành công !");
        setTimeout(() => {
          onSuccess(true);
          modals.closeAll();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  return (
    <Box size={"auto"}>
      <Text size="20px" mt={10} fw={500}>
        Bạn có chắc chắn muốn xóa các mức độ test này ?
      </Text>
      <Group justify="center" mt={10}>
        <Button
          type="button"
          color="red"
          onClick={handleDelete}
          leftSection={<IconCheck size={18} />}
          loading={visible}
          disabled={visible}
        >
          Xóa
        </Button>
      </Group>
    </Box>
  );
};

export default DeleteTestLevel;
